export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderGroups@2x.png";